class TableOfContents {

    constructor({ from, to, wrapperToc }) {
        this.postId = object_name.post_id;
        this.min_count = object_name.min_count;
        this.heading = object_name.headings
        this.index = 0;
        this.fromElement = from;
        this.toElement = to;
        this.wrapperToc = wrapperToc;
        this.headingElements = this.fromElement.querySelectorAll(this.heading);
        this.tocElement = document.createElement("div");
    }

    getMostImportantHeadingLevel() {
        let mostImportantHeadingLevel = 6; // <h6> heading level
        for (let i = 0; i < this.headingElements.length; i++) {
            let headingLevel = TableOfContents.getHeadingLevel(this.headingElements[i]);
            mostImportantHeadingLevel = (headingLevel < mostImportantHeadingLevel) ?
                headingLevel : mostImportantHeadingLevel;
        }
        return mostImportantHeadingLevel;
    }

    generateId(headingElement) {
        const tag = headingElement.tagName;
        const idElement = `${tag}_${this.postId}_${this.index}`;
        return idElement;
    }

    createToc() {
        if (this.min_count > this.index) return;

        this.toElement.appendChild(this.tocElement.firstChild);
        this.wrapperToc.style.display = "block";
    }

    static getHeadingLevel(headingElement) {
        switch (headingElement.tagName.toLowerCase()) {
            case "h2": return 2;
            case "h3": return 3;
            case "h4": return 4;
            case "h5": return 5;
            case "h6": return 6;
            default: return 1;
        }
    }

    generateToc() {
        let currentLevel = this.getMostImportantHeadingLevel() - 1,
            currentElement = this.tocElement;

        for (let i = 0; i < this.headingElements.length; i++) {

            if (this.headingElements[i].hasAttribute("data-content-table") && this.headingElements[i].getAttribute("data-content-table") == 'false') {
                continue;
            }
            let headingElement = this.headingElements[i],
                headingLevel = TableOfContents.getHeadingLevel(headingElement),
                headingLevelDifference = headingLevel - currentLevel,
                linkElement = document.createElement("a");
            this.index++;

            if (!headingElement.id) {
                headingElement.id = this.generateId(headingElement);
            }
            linkElement.href = `#${headingElement.id}`;
            let spanElement = document.createElement("span");
            spanElement.textContent = headingElement.textContent;
            linkElement.appendChild(spanElement);
            if (headingLevelDifference > 0) {
                for (let j = 0; j < headingLevelDifference; j++) {
                    let listElement = document.createElement("ul"),
                        listItemElement = document.createElement("li");
                    listElement.appendChild(listItemElement);
                    currentElement.appendChild(listElement);
                    currentElement = listItemElement;
                }
                currentElement.appendChild(linkElement);
            } else {
                for (let j = 0; j < -headingLevelDifference; j++) {
                    currentElement = currentElement.parentNode.parentNode;
                }
                let listItemElement = document.createElement("li");
                listItemElement.appendChild(linkElement);
                currentElement.parentNode.appendChild(listItemElement);
                currentElement = listItemElement;
            }

            currentLevel = headingLevel;
        }
        this.createToc();
    }

}

document.addEventListener("DOMContentLoaded", () => {
    const from = document.querySelector("#toc-plugin-main-content");
    const to = document.querySelector("#toc-items");
    const wrapperToc = document.querySelector("#table-of-contents");
    if (from && to) {
        new TableOfContents({
            from: from,
            to: to,
            wrapperToc: wrapperToc,
        }).generateToc()
    };
}
);